// 보이고 숨기 컴포넌트

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역
import React, { // 리액트 베이스
  useEffect, // 상태 변경 이벤트 헨들러
  useState, // 내부 상태 관리 훅
  useRef, // 객체 참조자
  forwardRef,
  Fragment, // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
  useCallback, // 상태 변경시까지 함수 재사용 장치 // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
} from 'react';
import M from 'src/com/keymansco/chihuahuaone/helper/mainHelper'; // 메인 헬퍼
import atom from 'src/com/keymansco/chihuahuaone/atom/index'; // 원자 컴포넌트
import molecule from 'src/com/keymansco/chihuahuaone/molecule/index'; // 분자 컴포넌트
import organism from 'src/com/keymansco/chihuahuaone/organism/index'; // 업무 컴포넌트
import template from 'src/com/keymansco/chihuahuaone/template/index'; // 템플릿 컴포넌트
import page from 'src/com/keymansco/chihuahuaone/page/index'; // 페이지 컴포넌트

// 동적 영역
import ShowNHideModel from './ShowNHideModel'; // 모델
import { Animated } from 'react-native';

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 컴포넌트 정의
// =================================================================================================
const ShowNHide = forwardRef((props, ref) => {
  let P = ShowNHideModel; // P 자동완성용
  P = props; // 속성. 읽기전용.

  // 내부 상태 [컴포넌트 자체 뷰 갱신 전용. private.]
  const [translateXAnimatedValue, setTranslateXAnimatedValue] = useState(
    new Animated.Value(P.width), // 애니메이션용 (비 벡터) 값
  );
  const [translateYAnimatedValue, setTranslateYAnimatedValue] = useState(
    new Animated.Value(P.height * -1), // 애니메이션용 (비 벡터) 값
  );
  const [rotateAnimatedValue, setRotateAnimatedValue] = useState(
    new Animated.Value(P.rotate), // 애니메이션용 (비 벡터) 값
  );
  const [scaleAnimatedValue, setScaleAnimatedValue] = useState(
    new Animated.Value(1), // 애니메이션용 (비 벡터) 값
  );
  const [opacityAnimatedValue, setOpacityAnimatedValue] = useState(
    new Animated.Value(1), // 애니메이션용 (비 벡터) 값
  );
  const [backgroundAnimatedValue, setBackgroundAnimatedValue] = useState(
    new Animated.Value(1), // 애니메이션용 (비 벡터) 값
  );

  // 외부 상태 [외부 개방용. public.]

  // 참조 변수
  // const domRef = useRef(null);

  // 상수
  const rotateAnimatedInterpolation = rotateAnimatedValue.interpolate(
    // 보간법. 입력 범위를 다른 출력 범위에 매핑.
    {
      inputRange: [0, 1],
      outputRange: ['360deg', '0deg'], // {0 = 360deg, 0.n 360~0deg = , 1 = 0deg}
    },
  );
  const backgroundAnimatedInterpolation = backgroundAnimatedValue.interpolate(
    // 보간법. 입력 범위를 다른 출력 범위에 매핑.
    {
      inputRange: [0, 1],
      outputRange: ['transparent', 'transparent'], // {0 = red, 0.n = red~blue , 1 = blue}
    },
  );

  // =================================================================================================
  // 컨테이너 컴포넌트 이벤트 핸들러
  // =================================================================================================
  // 컴포넌트 미운트 시 [componentDidMount, componentDidUpdate] [인자값 변경시 동작] [빈 배열 적용시 최초 마운트 때 한번 동작]
  useEffect(() => {
    M.log.info('ShowNHide');

    M.animation.start(
      // 애니메이션 시작 [완료 후 콜백 반환]
      M.animation.loop(
        // 애니메이션 반복
        M.animation.sequence(
          // 애니메이션을 순서대로 시작. 다음 애니메이션을 시작하기 전에 각 애니메이션이 완료 될 때까지 기다림.
          [
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(translateXAnimatedValue, P.width * 0.6, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(translateYAnimatedValue, P.height * 0.6 * -1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(rotateAnimatedValue, P.rotate, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(scaleAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(opacityAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(translateXAnimatedValue, P.width, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(translateYAnimatedValue, P.height * -1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(rotateAnimatedValue, P.rotate, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(scaleAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(opacityAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.6), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),

            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(translateXAnimatedValue, P.width * 0.5, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(translateYAnimatedValue, P.height * 0.5 * -1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(rotateAnimatedValue, P.rotate, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(scaleAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(opacityAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(translateXAnimatedValue, P.width, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(translateYAnimatedValue, P.height * -1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(rotateAnimatedValue, P.rotate, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(scaleAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(opacityAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.5), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),

            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(translateXAnimatedValue, P.width * 0.2, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(translateYAnimatedValue, P.height * 0.2 * -1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(rotateAnimatedValue, P.rotate, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(scaleAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(opacityAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(translateXAnimatedValue, P.width, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(translateYAnimatedValue, P.height * -1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(rotateAnimatedValue, P.rotate, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(scaleAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(opacityAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
            M.animation.parallel(
              // 애니메이션 배열을 동시에 시작
              [
                // 이동
                M.animation.timing(backgroundAnimatedValue, 1, 3 * 0.2), // 시간이 지남에 따라 값에 애니메이션을 적용 간소화
              ],
            ),
          ], // animations
          -1, // count
        ),
      ),
    ); // 애니메이션 시작 [완료 후 콜백 반환]

    // 컴포넌트 언마운트 시(componentWillUnmount)
    return () => {};
  }, []);

  // =================================================================================================
  // 컴포넌트 함수 정의
  // =================================================================================================

  // =================================================================================================
  // 그리기
  // =================================================================================================
  // 렌더링(render)
  return (
    <atom.layout.Box // 박스[div]
      // 주입 속성
      {...P}
      ref={ref}
      style={{
        // 인라인 스타일 [스타일 분리시, 모양새 추정에 불리.]
        ...P.style,
      }}
    >
      <Animated.View
        style={{
          alignSelf: P.alignSelf,
          // backgroundColor: backgroundAnimatedInterpolation,
          height: '100%',
          opacity: opacityAnimatedValue,
          transform: [{ translateX: translateXAnimatedValue }, { translateY: translateYAnimatedValue }, { rotate: rotateAnimatedInterpolation }, { scale: scaleAnimatedValue }],
          width: '100%',
        }}
      >
        {P.children}
      </Animated.View>
    </atom.layout.Box>
  );
});

// =================================================================================================
// 내보내기
// =================================================================================================
export default ShowNHide;
